import { getStore } from './stores';
import { runInAction } from 'mobx';
const cssClass = 'CAWCTA';
const selectors = {
	CTA: `.${cssClass}-cta`,
	CAWTriggers: `.${cssClass}-cta--trigger`,
	CAWSelects: '.DestinationPicker-container select',
};

const setCAWProperty = async (owsCode, attempts) => {
	const planStore = await getStore('planStore');
	const updateCAWSelectsValue = owsCode => {
		let $CAWSelects = $(selectors.CAWSelects);
		if ($CAWSelects.length > 0) {
			$CAWSelects.val(owsCode);
			runInAction(() => planStore?.updateSearch({ hotelCode: owsCode }));
		}
	};

	if (window.cawComponentLoaded) {
		updateCAWSelectsValue(owsCode);
	} else {
		window.addEventListener('cawComponentLoaded', () => {
			updateCAWSelectsValue(owsCode);
		});
	}
};

const getAllCAWTriggers = () => {
	return $(selectors.CAWTriggers);
};

const handleCAWTriggerClick = e => {
	const $element = $(e.currentTarget);
	if ($element) {
		const owsCode = $element.attr('data-ows-code');

		if (owsCode) {
			setCAWProperty(owsCode);
		}
	}
};

export default function initialize() {
	const $allCAWTriggers = getAllCAWTriggers();
	if ($allCAWTriggers.length > 0) {
		$allCAWTriggers.on('click', handleCAWTriggerClick);
	}
}
